module.exports = __webpack_public_path__ + "img/6d85267.jpg";